import React from 'react';

export const PageFooter: React.FC = () => {
  return <></>;
};
